import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Box } from '../Box/Box'
import { Text, TEXT_VARIANT_BOLD } from '../Text/Text'
import { Toggle } from '../Toggle/Toggle'
import { Collapsible } from '../Collapsible/Collapsible'

const StyledBox = styled(Box)`
    padding: 16px 30px;
`

const StyledText = styled(Text)`
    line-height: 26px !important;
    cursor: pointer;
`

const StyledToggle = styled(Toggle)`
    float: right;
`

const ChildrenContainer = styled.div`
${(props) =>
    props.collapsed
      ? `` : `padding-top: 10px`}
`

export const ToggleBox = ({
  title,
  onClickCallback,
  checked,
  className,
  children,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <div data-mu-test={dataAttributeTest} className={className}>
      <StyledBox collapsible={false} >
        <StyledText
          variant={TEXT_VARIANT_BOLD}
          htmlElement='span'
          onClick={onClickCallback}
        >
          {title}
        </StyledText>
        <StyledToggle
          checked={checked}
          onChange={onClickCallback}
          value={checked}
        />
        {children &&
        <ChildrenContainer collapsed={!checked}>

          <Collapsible collapsed={!checked}>
            {children}
          </Collapsible>
        </ChildrenContainer>
        }
      </StyledBox>

    </div>
  )
}

ToggleBox.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node
}
